/** The audit log. Read only; nothing here writes, because nothing may. */

import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { AuditPage } from '@/api/schema';

export const AUDIT_KEY = ['audit'] as const;

export type AuditFilters = {
  page: number;
  per_page: number;
  entity: string;
  method: string;
};

export function useAuditLog(filters: AuditFilters) {
  return useQuery({
    queryKey: [...AUDIT_KEY, filters],
    queryFn: () => api.get<AuditPage>('/api/v1/audit', { query: { ...filters } }),
    placeholderData: (previous) => previous,
  });
}
